(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3264,3153],{

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 29651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FaChevronLeft; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaChevronLeft(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 320 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 16382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaChevronLeft.js
var FaChevronLeft = __webpack_require__(29651);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaChevronRight.js
var FaChevronRight = __webpack_require__(20303);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/hi/HiChevronDoubleLeft.js

function HiChevronDoubleLeft(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fillRule": "evenodd",
        "d": "M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z",
        "clipRule": "evenodd"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/hi/HiChevronDoubleRight.js
var HiChevronDoubleRight = __webpack_require__(23534);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/Breadcrumb/index.js
var Breadcrumb = __webpack_require__(49011);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/fetch/getGAUserID.js
var getGAUserID = __webpack_require__(12453);
// EXTERNAL MODULE: ./common/fetch/post.js
var post = __webpack_require__(92559);
// EXTERNAL MODULE: ./components/atoms/Icon/bi/BiLoaderAlt.js
var BiLoaderAlt = __webpack_require__(7778);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTimes.js
var FaTimes = __webpack_require__(11856);
// EXTERNAL MODULE: ./components/atoms/Input/index.js
var Input = __webpack_require__(66865);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/whitepaper/FormWhitepaper/Index.module.scss
var Index_module = __webpack_require__(55675);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/whitepaper/FormWhitepaper/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















/** ========== */





var FormDowload = function FormDowload(_ref) {
  var onHide = _ref.onHide;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var _useContext = (0,react.useContext)(contexts/* ToastContext */.uL),
      openAlert = _useContext.openAlert,
      setOpenAlert = _useContext.setOpenAlert;

  var recaptchaRef = (0,react.useRef)();
  (0,react.useEffect)(function () {
    var getHash = window.location.hash || "";

    if (getHash.length > 0) {
      var _document$getElementB;

      (_document$getElementB = document.getElementById(getHash.replace("#", ""))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
    }
  }, []);

  var handlingSuccess = function handlingSuccess() {
    reset();
    clearErrors();
  };

  var onSubmitEbook = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,getGAUserID/* default */.Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.contact_from_id = 39;
                document.getElementById("popup-content-panel").style.display = "none"; // Axios
                //   .post(
                //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/whitepaper`,
                //     Data,
                //     {
                //       Headers: {
                //         "captcha-response": token,
                //       },
                //     }
                // )

                (0,post/* default */.Z)({
                  api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/whitepaper"),
                  data: dataSend,
                  token: token
                }).then(function (res) {
                  if (res.state) {
                    openAlert(5000, "custom", {
                      element: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                            src: "/assets/icons/checked.png",
                            width: 90,
                            height: 92,
                            alt: "icon success",
                            className: "mb-6"
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
                          children: "You're all set!"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-sm text-bbc-gray",
                          children: "Your whitepaper will be sent to your inbox shortly. Please check your email to view your download."
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                          onClick: function onClick() {
                            setOpenAlert(false);
                          },
                          className: "relative mt-4 inline-flex  items-center justify-center rounded-full bg-bbc-brand-500 p-2 text-base text-white hover:bg-bbc-secondary-100 ",
                          style: {
                            width: "160px"
                          },
                          children: "OK"
                        })]
                      })
                    });
                    setTimeout(function () {
                      onHide();
                    }, 5000);
                    handlingSuccess();
                  } else {
                    openAlert(5000, "error");
                    setTimeout(function () {
                      onHide();
                    }, 5000);
                    console.eror("error");
                  }
                })["catch"](function (e) {
                  openAlert(5000, "error");
                  setTimeout(function () {
                    onHide();
                  }, 5000);
                  console.log(e, "error");
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmitEbook(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(onSubmitEbook),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputText */.oH, {
          className: "w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0",
          disabled: isSubmitting,
          placeholder: "First name",
          register: register,
          errors: errors,
          name: "first_name"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputText */.oH, {
          className: "w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0",
          disabled: isSubmitting,
          placeholder: "Last name",
          register: register,
          errors: errors,
          name: "last_name"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* InputEmail */.j7, {
          className: "w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0",
          disabled: isSubmitting,
          placeholder: "Email",
          register: register,
          errors: errors,
          requiredText: "This field is required"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "invisible h-0 w-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
          ref: recaptchaRef,
          sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
          badge: "inline",
          size: "invisible"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative flex items-center justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
            id: "read-policy",
            type: "checkbox"
          }, register("read-policy", {
            required: {
              value: true,
              message: "Please accept Privacy Policy"
            }
          })), {}, {
            className: "bbc-checkbox mr-2 cursor-pointer rounded-full border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "read-policy",
            className: "cursor-pointer font-normal text-bbc-white",
            dangerouslySetInnerHTML: {
              __html: "I accept the <a href='/offshore/privacy-policy' class='underline' target='_blank' rel='nofollow noreferrer'>Privacy Policy</a>"
            }
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-6 text-center lg:mt-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
          disabled: isSubmitting,
          variant: "primary",
          type: "submit",
          className: "w-full rounded-full border border-bbc-white bg-transparent py-2 font-semibold text-bbc-white duration-200 ease-in-out hover:bg-bbc-white hover:text-bbc-primary",
          children: [isSubmitting && /*#__PURE__*/(0,jsx_runtime.jsx)(BiLoaderAlt/* BiLoaderAlt */.s, {
            className: "mr-1 inline-block animate-spin",
            size: 20
          }), "Download Now"]
        })
      })]
    })
  });
};

var Component = function Component(_ref3) {
  var show = _ref3.show,
      onHide = _ref3.onHide;

  var closeModal = function closeModal() {
    onHide();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
        show: show,
        as: "div",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
          as: "div",
          unmount: false,
          className: "fixed inset-0 overflow-y-auto",
          style: {
            zIndex: 99
          },
          onClose: closeModal,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            "aria-hidden": "true",
            className: "min-h-screen px-4 text-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
              as: react.Fragment,
              enter: "ease-out duration-300",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "ease-in duration-200",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
                className: "fixed inset-0 bg-slate-900 opacity-70"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block h-screen align-middle",
              "aria-hidden": "true",
              children: "\u200B"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
              as: react.Fragment,
              enter: "ease-out duration-300",
              enterFrom: "opacity-0 scale-95",
              enterTo: "opacity-100 scale-100",
              leave: "ease-in duration-200",
              leaveFrom: "opacity-100 scale-100",
              leaveTo: "opacity-0 scale-95",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                id: "popup-content-panel",
                className: "".concat((Index_module_default()).WhitepaperModal, " relative inline-flex w-full transform flex-col justify-center overflow-hidden px-4 pt-6 pb-6 text-left align-middle transition-all lg:px-10 lg:pb-10"),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/offshore/guide-and-tool/whitepaper/bg_form-offshore-whitepaper.png",
                  alt: "bg_form-offshore-whitepaper",
                  className: "absolute left-0 top-0 z-0 h-full object-cover",
                  width: 1110,
                  height: 405
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "absolute top-4 right-4 z-20 mb-4 text-right leading-none lg:mb-8",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: closeModal,
                    className: "rounded-full border border-bbc-white p-[1px]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimes/* FaTimes */.a, {
                      className: "text-bbc-white",
                      size: 16
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "row relative z-10 items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "col-12 lg:col-4",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h3",
                      text: "Want Happier Clients And Healthier Profits?",
                      className: "".concat((Index_module_default()).WhitepaperTitle, " mb-4 text-center font-semibold text-bbc-white lg:text-left")
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-center text-bbc-white lg:text-left",
                      children: "Explore how firms are simplifying entity formation and enhancing client value."
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "col-12 flex justify-center py-6 lg:col-4 lg:py-0",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/images/offshore/guide-and-tool/whitepaper/modalwhitepaper-offshore-guide.png",
                      alt: "whitepaper-guide",
                      width: 224,
                      height: 315
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "col-12 lg:col-4",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormDowload, {
                      onHide: onHide
                    })
                  })]
                })]
              })
            })]
          })
        })
      })
    })
  });
};

Component.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {},
  checkboxTextClassName: ""
};
/* harmony default export */ var FormWhitepaper = (Component);
/** ========== */
// EXTERNAL MODULE: ./components/templates/offshore/guide-and-tool/whitepaper/Index.module.scss
var whitepaper_Index_module = __webpack_require__(30103);
var whitepaper_Index_module_default = /*#__PURE__*/__webpack_require__.n(whitepaper_Index_module);
;// CONCATENATED MODULE: ./components/templates/offshore/guide-and-tool/whitepaper/index.js


function whitepaper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function whitepaper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { whitepaper_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { whitepaper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-negated-condition */
























var WhitePaperTemplate = function WhitePaperTemplate(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(false),
      showFormDownload = _useState[0],
      setShowFormDownload = _useState[1];

  var _useState2 = (0,react.useState)(),
      screen = _useState2[0],
      setScreen = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      indexTitle = _useState3[0],
      setIndexTitle = _useState3[1];

  var swiperRef = (0,react.useRef)();
  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Banner/* default */.Z, {
      minHeightBanner: "lg:min-h-[1370px] min-h-[750px] relative",
      bgStyle: {
        background: "none"
      },
      children: [screen !== "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
        alt: "banner-img",
        className: "absolute left-0 top-0 h-full w-full"
      }, data.banner.imageMb)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
        alt: "banner-img",
        className: "absolute left-0 top-0 h-full w-full"
      }, data.banner.image)), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 mb-10",
        children: [Array.isArray(data.banner.breadcrumbs) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex w-full justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-6 inline-block w-auto text-center text-bbc-white lg:mb-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
              items: data.banner.breadcrumbs
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative mb-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
            className: "relative z-10 mb-4 text-center text-4xl font-semibold leading-[50px] text-bbc-white lg:mb-2 lg:text-bbc-40px lg:text-[64px] lg:leading-[96px]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "relative z-10",
              children: ["Entity Formation ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                className: "block lg:hidden"
              }), "On ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                className: "hidden lg:block"
              }), "A", " "]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "relative",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "absolute -bottom-2 left-0 z-0 grid w-full place-items-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                  alt: "bg-title"
                }, data.banner.bgTitle))
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "relative z-10 inline-block",
                children: "New Horizon"
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden text-center text-bbc-white lg:block",
          dangerouslySetInnerHTML: {
            __html: data.banner.description
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "block text-center text-bbc-white lg:hidden",
          dangerouslySetInnerHTML: {
            __html: data.banner.descriptionMobile
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-6 mb-2 flex justify-center lg:mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            onClick: function onClick() {
              return setShowFormDownload(true);
            },
            className: "rounded-full bg-bbc-yellow-500 px-12 py-3 text-lg font-semibold text-bbc-white duration-200 ease-in-out hover:bg-bbc-white hover:text-bbc-yellow-500",
            children: "Explore Now"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative block lg:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
            alt: "tablet-whitepaper",
            className: "relative z-10"
          }, data.banner.imageBottom))
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "absolute bottom-0 left-0 grid w-full place-items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/guide-and-tool/whitepaper/wave1-offshore-whitepaper.png",
          alt: "wave1",
          className: "absolute -bottom-2 left-0 right-0 z-0 w-full lg:-bottom-1 2xl:max-h-[700px]",
          width: 1920,
          height: 676
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
            alt: "tablet-whitepaper",
            className: "relative z-10"
          }, data.banner.imageBottom))
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "relative mb-10 -mt-10 bg-[#f7fdff] sm:mb-0 xl:-mb-16",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container overflow-hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h2",
          className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: data.dataServiceFirm.title
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row pb-8 lg:pb-0",
          children: [data.dataServiceFirm.leftContent && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col justify-center text-center  lg:w-1/2 lg:text-left",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-4 hidden lg:block",
              children: data.dataServiceFirm.leftContent.description
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-4 block lg:hidden",
              children: data.dataServiceFirm.leftContent.descriptionMobile
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-2xl font-semibold text-[#FF5630]",
              children: data.dataServiceFirm.leftContent.title
            }), data.dataServiceFirm.leftContent.listContent && data.dataServiceFirm.leftContent.listContent.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mt-4 lg:mt-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-4 text-2xl font-semibold text-bbc-brand-800",
                  children: item.subTitle
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: item.content
                })]
              }, index);
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 grid w-full grid-cols-2 grid-rows-2 gap-3 lg:mt-0 lg:w-1/2 xl:gap-7",
            children: data.dataServiceFirm.rightContent && data.dataServiceFirm.rightContent.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "rounded-[32px] p-6 lg:px-7 lg:py-10 xl:h-[255px] xl:w-[255px]",
                style: {
                  background: "".concat(item.background)
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex h-full flex-col justify-between",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                    alt: item.text.toLowerCase(),
                    className: "w-14 lg:w-auto"
                  }, item.icon)), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-normal mt-2 font-semibold text-bbc-white lg:mt-0 lg:text-2xl",
                    children: item.text
                  })]
                })
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-9",
          children: [data.dataTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "ml-[287px] mb-6 hidden lg:block",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-2xl font-semibold text-bbc-brand-700",
              children: data.dataTitle[indexTitle].title
            }), data.dataTitle[indexTitle].description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mt-4",
              children: data.dataTitle[indexTitle].description
            })]
          }), data.dataChart && /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Group */.OK.Group, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex ".concat((whitepaper_Index_module_default()).charts, " relative z-10 flex-col lg:flex-row"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.List */.OK.List, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    boxShadow: "0px 25px 22px rgba(0, 126, 255, 0.15)"
                  },
                  className: "relative flex min-w-[255px] flex-col items-start rounded-2xl bg-bbc-white p-4 lg:mr-8",
                  children: data.dataChart.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab */.OK, {
                      as: "div",
                      className: function className(_ref2) {
                        var selected = _ref2.selected;
                        return selected ? "mb-4 cursor-pointer border-bbc-brand-600 text-bbc-brand-600 last:mb-0" : " ".concat("mb-4 cursor-pointer border-transparent bg-transparent text-bbc-neutral-600 last:mb-0 hover:text-bbc-brand-600", " ");
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                        onClick: function onClick() {
                          return setIndexTitle(index);
                        },
                        className: "".concat(indexTitle == index ? "font-semibold" : "font-normal"),
                        children: item.title
                      })
                    }, index);
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                className: "mt-6 w-full lg:mt-0",
                children: data.dataChart.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                    as: "div",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mb-6 block text-center lg:hidden",
                      children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "text-2xl font-semibold text-bbc-brand-700",
                        children: item.title
                      }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "mt-4",
                        children: item.description
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mb-6 rounded-lg bg-bbc-white p-4 drop-shadow-xl xl:py-6 xl:px-9",
                      children: [item.text && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "mb-4 text-center",
                        children: item.text
                      }), item.image && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread(whitepaper_objectSpread({}, item.image), {}, {
                        alt: "chart-image"
                      })), item.style && item.style == "booming" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "".concat(item.style, " text-[6px] leading-[10px] md:text-sm xl:text-base"),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "sidebar",
                          children: item.vertical && item.vertical.map(function (el, idx) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              children: el
                            }, idx);
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "content",
                          children: item.listItem && item.listItem.map(function (el, idx) {
                            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "item",
                              style: {
                                height: "".concat(screen !== "DESKTOP" ? el.heightMb : el.height)
                              },
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: "dataHolder",
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: "data",
                                  dangerouslySetInnerHTML: {
                                    __html: el.data
                                  }
                                })
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: "percentHolder",
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: "percent",
                                  style: {
                                    height: "100%"
                                  }
                                })
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: "year",
                                children: el.year
                              })]
                            }, idx);
                          })
                        })]
                      }), item.style && item.style == "players" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "".concat(item.style),
                        children: item.listItem && item.listItem.map(function (el, idx) {
                          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "mt-1 flex lg:mt-0",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "mr-4 w-1/4 text-right",
                              children: el.name
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "flex w-3/4 items-center overflow-hidden",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: "item",
                                style: {
                                  width: "".concat(el.width)
                                }
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: "itemText",
                                children: el.value
                              })]
                            })]
                          }, idx);
                        })
                      }), item.style && item.style == "powerhouses" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "".concat(item.style),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "leftContent",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "flex h-full w-full flex-col justify-center",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "text-right text-[6px] font-medium lg:text-[12px]",
                              children: "$160 billion"
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "column",
                              children: item.leftContent && item.leftContent.map(function (el, idx) {
                                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                  className: "item",
                                  style: {
                                    height: "".concat(el.height)
                                  },
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    className: "flex w-2/3 items-center justify-end pr-1 text-[6px] font-medium leading-[10px] lg:pr-2 lg:text-[12px]",
                                    children: el.name
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    style: {
                                      backgroundColor: "".concat(el.color)
                                    },
                                    className: "percent w-1/3 text-[6px] leading-[10px] lg:text-sm",
                                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                      className: "text",
                                      children: el.value ? el.value : ""
                                    })
                                  })]
                                }, idx);
                              })
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "text-right text-[6px] font-medium lg:text-[12px]",
                              children: "Market size"
                            })]
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "rightContent",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "mb-2 text-[10px] font-semibold text-bbc-yellow-500 lg:mb-6 lg:text-base",
                            children: item.chartTitle
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
                            className: "border-bbc-brand-700"
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [item.rightContent && item.rightContent.map(function (el, idx) {
                              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "row mt-2 text-[6px] font-medium leading-[10px] text-bbc-brand-800 lg:text-[10px] xl:text-sm",
                                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                  className: "col-4 flex items-center justify-end pl-0 pr-1 lg:pr-4",
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    children: el.name
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                                    alt: el.name,
                                    className: "ml-2 w-3 lg:w-6"
                                  }, el.image))]
                                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                  className: "col-8 flex items-center overflow-hidden p-0",
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    className: "percent mr-1 rounded-full lg:mr-2",
                                    style: {
                                      width: "".concat(el.width),
                                      background: "linear-gradient(223.53deg, #3EDCEB 31.56%, #2594FF 65.16%, #5533FF 102.22%)"
                                    }
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    className: "value",
                                    children: el.value
                                  })]
                                })]
                              }, idx);
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "absolute bottom-20 right-2 grid h-16 w-16 place-content-center rounded-full bg-bbc-brand-600 text-center text-[6px] leading-[10px] text-bbc-white sm:right-6 sm:h-24 sm:w-24 sm:text-[10px] sm:leading-4 md:right-10 lg:bottom-32 xl:h-36 xl:w-36 xl:text-sm",
                              children: ["~80% of", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " the global", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " industry"]
                            })]
                          })]
                        })]
                      })]
                    }), item.note && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-sm text-[#B7B7B7]",
                      children: item.note
                    }), item.source && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-sm text-[#B7B7B7]",
                      dangerouslySetInnerHTML: {
                        __html: item.source
                      }
                    })]
                  }, index);
                })
              })]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative mb-5 overflow-hidden bg-[#f7fdff] pt-4 pb-16 sm:pt-20 lg:mb-20 lg:pt-52 lg:pb-24",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
        alt: "bg-adversity",
        className: "absolute left-0 bottom-0 z-0 hidden h-full w-full sm:block"
      }, data.dataAdversity.background)), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "block after:absolute after:top-2 after:-right-10 after:z-0 after:h-[97%] after:w-[120%] after:-rotate-2 after:bg-bbc-brand-700 after:content-[''] sm:hidden after:sm:-right-3 after:sm:w-[105%]"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative z-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
          as: "h2",
          className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-white lg:mb-10 lg:text-bbc-40px",
          children: ["In Adversity Lies ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
            className: "block lg:hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "relative text-bbc-yellow-500",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
              alt: "bg-text",
              className: "absolute left-0 top-0 z-0 w-full"
            }, data.banner.bgTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "relative z-10",
              children: "Opportunity"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6 hidden text-center text-bbc-white lg:block",
          children: data.dataAdversity.description1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "hidden text-center font-semibold text-bbc-white lg:block",
          children: data.dataAdversity.description2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6 block text-center text-bbc-white lg:hidden",
          children: data.dataAdversity.descriptionMobile
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 grid grid-cols-2 grid-rows-2 gap-7",
            children: data.dataAdversity.listContent && data.dataAdversity.listContent.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-full",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                  className: "h-full",
                  modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_],
                  preloadImages: false,
                  allowTouchMove: false,
                  navigation: {
                    nextEl: ".slider-button-next",
                    prevEl: ".slider-button-prev"
                  },
                  slidesPerView: 1,
                  spaceBetween: 50,
                  children: item.data.map(function (el, idx) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full flex-col justify-between rounded-3xl ".concat(idx == 0 ? "bg-bbc-white" : "bg-bbc-yellow-500", " p-8"),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                            alt: "ad-icon",
                            className: "mb-4"
                          }, el.icon)), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "mb-4 text-xl font-semibold text-bbc-brand-700",
                            children: el.title
                          }), el.content && el.content.map(function (el, idx) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                              className: "mb-6 font-normal last:mb-0",
                              dangerouslySetInnerHTML: {
                                __html: el
                              }
                            }, idx);
                          }), el.customText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            dangerouslySetInnerHTML: {
                              __html: el.customText
                            }
                          })]
                        }), idx == 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                            className: "slider-button-next flex items-center font-medium text-bbc-secondary-100 hover:text-bbc-yellow-500",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleRight/* HiChevronDoubleRight */.i, {}), " See what opportunity awaits you!"]
                          })
                        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          children: [el.sourceText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "mb-4 text-sm font-normal text-[#000000a6]",
                            dangerouslySetInnerHTML: {
                              __html: el.sourceText
                            }
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                            className: "slider-button-prev flex items-center font-medium text-bbc-secondary-100 hover:text-bbc-white",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleLeft, {}), " Back"]
                          })]
                        })]
                      })
                    }, idx);
                  })
                })
              }, index);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "block lg:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            spaceBetween: 30,
            rewind: true,
            modules: [swiper_esm/* Pagination */.tl],
            pagination: {
              el: ".bbc-slide-pagination",
              clickable: true,
              bulletClass: "bbc-pagination-bullet !border-bbc-white",
              bulletActiveClass: "bbc-pagination-bullet-active h-2.5 w-10 !bg-bbc-white"
            },
            children: [data.dataAdversity.listContent && data.dataAdversity.listContent.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                  modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_],
                  className: "h-full",
                  preloadImages: false,
                  allowTouchMove: false,
                  navigation: {
                    nextEl: ".slider-button-next",
                    prevEl: ".slider-button-prev"
                  },
                  slidesPerView: 1,
                  spaceBetween: 50,
                  children: item.data.map(function (el, idx) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col rounded-3xl ".concat(idx == 0 ? "bg-bbc-white" : "bg-bbc-yellow-500", " p-6"),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                            alt: "ad-icon",
                            className: "mb-4"
                          }, el.icon)), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "mb-4 text-xl font-semibold text-bbc-brand-700",
                            children: el.titleMb
                          }), el.contentMb && el.contentMb.map(function (el, idx) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                              className: "mb-6 font-normal last:mb-0",
                              dangerouslySetInnerHTML: {
                                __html: el
                              }
                            }, idx);
                          }), !el.customTextMb ? el.customText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            dangerouslySetInnerHTML: {
                              __html: el.customText
                            }
                          }) : el.customTextMb && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            dangerouslySetInnerHTML: {
                              __html: el.customTextMb
                            }
                          })]
                        }), idx == 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "slider-button-next mt-6",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                            className: "flex text-left font-medium text-bbc-secondary-100 hover:text-bbc-yellow-500",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleRight/* HiChevronDoubleRight */.i, {
                              className: "mt-1"
                            }), " ", "See what opportunity awaits you!"]
                          })
                        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "",
                          children: [el.sourceText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "mb-4 mt-6 text-sm font-normal text-[#000000a6]",
                            dangerouslySetInnerHTML: {
                              __html: el.sourceText
                            }
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                            className: "slider-button-prev mt-6 flex items-center font-medium text-bbc-secondary-100",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleLeft, {}), " Back"]
                          })]
                        })]
                      })
                    }, idx);
                  })
                })
              }, index);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bbc-slide-pagination z-20 pt-6 text-center"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-6 hidden text-center text-sm font-normal text-[#FAFAFAA6] lg:block",
          children: data.dataAdversity.note
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-5 flex justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            as: "a",
            target: "_blank",
            href: "/offshore/contact-us",
            className: "rounded-full bg-bbc-yellow-500 py-3 px-6 font-semibold text-bbc-white duration-200 ease-out hover:bg-bbc-white hover:text-bbc-yellow-500 hover:drop-shadow-lg",
            children: "Contact Us"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full lg:w-1/2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-6 block lg:hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/guide-and-tool/whitepaper/incorporation-offshore-whitepaper.png",
              alt: "incorporation",
              width: 656,
              height: 488
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
            as: "h2",
            className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-700 lg:mb-10 lg:text-bbc-40px",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "relative mr-2 px-2 text-[#FF5630] lg:px-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                alt: "bg-text",
                className: "absolute left-0 bottom-1 z-0 w-full lg:bottom-0"
              }, data.banner.bgTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "relative z-10",
                children: "Digital"
              })]
            }), "Incorporation"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 text-center lg:text-left",
            children: "As the need for entity formation grows, firms must reconsider how they will meet these demands and be more competitive when pitching for new projects."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-6 text-center lg:text-left",
            children: [" ", "In this context, digital adoption is inevitable, and"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 flex justify-center lg:col-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/offshore/guide-and-tool/whitepaper/70-offshore-whitepaper.png",
                alt: "70-percent",
                className: "mx-auto w-3/4 lg:w-full",
                width: 263,
                height: 138
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 mt-6 text-center lg:col-6 lg:mt-0 lg:text-left",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-2xl font-semibold",
                children: "of firms stated that they are investing in digital incorporation to help their clients"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden w-1/2 lg:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/offshore/guide-and-tool/whitepaper/incorporation-offshore-whitepaper.png",
            alt: "incorporation",
            width: 656,
            height: 488
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-10 overflow-x-hidden lg:container lg:mt-20 lg:overflow-visible",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative px-4 pt-10 pb-10 text-bbc-white lg:bg-none lg:px-20 lg:pb-[60px] lg:pt-[100px]",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              zIndex: "1"
            },
            className: "absolute left-2 top-0 hidden h-full w-full rotate-2 rounded-[40px] bg-[#00A6FF] after:absolute after:top-2 after:-right-16 after:z-0 after:h-[97%] after:w-[110%] after:-rotate-3 after:rounded-[40px] after:bg-bbc-brand-700 after:content-[''] lg:block"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "block after:absolute after:top-4 after:-right-10 after:z-0 after:h-[97%] after:w-[120%] after:-rotate-2 after:bg-bbc-brand-700 after:content-[''] after:sm:-right-3 after:sm:w-[105%] lg:hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            autoplay: false,
            rewind: true,
            modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Pagination */.tl],
            onBeforeInit: function onBeforeInit(swiper) {
              swiperRef.current = swiper;
            },
            spaceBetween: 30,
            pagination: {
              el: ".bbc-slide-pagination",
              clickable: true,
              bulletClass: "bbc-pagination-bullet !border-bbc-white",
              bulletActiveClass: "bbc-pagination-bullet-active h-2.5 w-10 !bg-bbc-white"
            },
            children: [data.dataIncorpSlide.length > 0 && data.dataIncorpSlide.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: "!h-auto",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "row h-full lg:items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "grid place-items-center lg:col-4 lg:place-items-end",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, whitepaper_objectSpread({
                      className: "w-40 lg:w-full"
                    }, item.image))
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "col-12 lg:col-8 lg:mt-0",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h4",
                      className: "text-center text-xl font-semibold text-bbc-yellow-300 lg:text-left lg:text-2xl ",
                      children: item.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "lg:pr-16",
                      children: screen == "DESKTOP" ? item.content.map(function (el, idx) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          className: "mt-4 flex",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "mr-2 block pt-1",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                              className: " text-bbc-green-400"
                            })
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: el
                          })]
                        }, idx);
                      }) : item.contentMb.map(function (el, idx) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "mt-4 flex",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "text-center",
                            children: el
                          })
                        }, idx);
                      })
                    })]
                  })]
                })
              }, index);
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bbc-slide-pagination z-20 pt-6 text-center lg:pb-10"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              backgroundColor: "rgba(191, 189, 189, 0.2)"
            },
            onClick: function onClick() {
              var _swiperRef$current;

              return (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : _swiperRef$current.slidePrev();
            },
            className: "bbc-button-prev absolute top-1/2 left-12 z-10 hidden h-12 w-12 -translate-y-1/2 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-150 ease-in-out hover:opacity-60 lg:flex",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronLeft/* FaChevronLeft */.b, {
              size: 16,
              className: "text-white"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              backgroundColor: "rgba(191, 189, 189, 0.2)"
            },
            onClick: function onClick() {
              var _swiperRef$current2;

              return (_swiperRef$current2 = swiperRef.current) === null || _swiperRef$current2 === void 0 ? void 0 : _swiperRef$current2.slideNext();
            },
            className: "bbc-button-next absolute top-1/2 right-14 z-10 hidden h-12 w-12 -translate-y-1/2 translate-x-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-150 ease-in-out hover:opacity-60 lg:flex",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronRight/* FaChevronRight */.D, {
              size: 16,
              className: "text-white"
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "xl:-mb-24",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row lg:items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mb-6 block lg:hidden",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/offshore/guide-and-tool/whitepaper/goglobal-offshore-whitepaper.png",
                  alt: "go-global ",
                  className: "object-center",
                  width: 538,
                  height: 370
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
              as: "h2",
              className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-700 lg:mb-10 lg:text-left lg:text-bbc-40px",
              children: ["Go Digital", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "ml-2 text-[#FF5630]",
                children: "Go Global"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: "hidden text-left lg:block",
              children: ["Whether your firms focus on consulting, advisory, accounting, or other professional services,", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-semibold text-bbc-brand-600",
                children: "BBCIncorp"
              }), " ", "digital incorporation helps you drive better clients' experiences while adapting to global regulations seamlessly, without any headache."]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "block text-center lg:hidden",
              children: "We help you drive better clients' experiences while adapting to global regulations seamlessly, without any headache."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 hidden lg:col-6 lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/guide-and-tool/whitepaper/goglobal-offshore-whitepaper.png",
              alt: "go-global",
              width: 538,
              height: 370
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "".concat((whitepaper_Index_module_default()).lastSection, " relative -mb-20 min-h-screen pb-32 sm:-mb-20 md:-mb-32 md:pb-32 lg:-mb-36 lg:pb-44 xl:-mb-44 xl:pt-[125px]"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/guide-and-tool/whitepaper/city_Mb-offshore-whitepaper.png",
        alt: "city-background",
        className: "absolute left-0 bottom-0 right-0 z-0 block h-full w-full sm:hidden",
        width: 375,
        height: 1455
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/guide-and-tool/whitepaper/bgcity-offshore-whitepaper.png",
        alt: "city-background",
        className: "absolute left-0 bottom-0 right-0 z-0 hidden h-full sm:block 2xl:w-full",
        width: 1920,
        height: 1119
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative z-10 h-full",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
          as: "h2",
          className: "flex flex-col items-center text-bbc-30px font-semibold uppercase text-bbc-brand-700 lg:mb-32 lg:text-bbc-40px",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "What We Offer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/offshore/guide-and-tool/whitepaper/curvedline-offshore-whitepaper.png",
            alt: "curved-line",
            width: 272,
            height: 18
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-cols-1 lg:grid-cols-3 lg:gap-8",
          children: data.dataBeOurPartner && data.dataBeOurPartner.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col items-center ".concat(index == 1 ? "lg:mt-20" : ""),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                as: "a",
                target: "_blank",
                href: item.link,
                className: "z-10 w-4/5 translate-y-1/2 rounded-lg py-3 text-center text-2xl font-semibold text-bbc-white duration-200 ease-in ".concat(index == 0 ? "bg-[#E5006E] hover:bg-[#a60351]" : index == 1 ? "bg-[#F33E95] hover:bg-[#ad2d6b] " : "bg-[#FF8FC5] hover:bg-[#b3648a]", " ]"),
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "rounded-3xl border border-bbc-white bg-[#00000059] px-8 pb-6 pt-12 text-center text-bbc-white backdrop-blur-md",
                children: item.description
              })]
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-10 flex justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            as: "a",
            target: "_blank",
            href: "/offshore/become-our-partner",
            className: " rounded-full bg-bbc-yellow-500 py-3 px-6 font-semibold text-bbc-white duration-200 ease-out hover:bg-bbc-white hover:text-bbc-yellow-500 hover:drop-shadow-lg",
            children: "Be Our Partner"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormWhitepaper, {
      show: showFormDownload,
      onHide: function onHide() {
        return setShowFormDownload(false);
      }
    })]
  });
};

/* harmony default export */ var whitepaper = (WhitePaperTemplate);
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/whitepaper/data.json
var data_namespaceObject = JSON.parse('{"banner":{"title":"Entity Formation On <br />A New Horizon","bgTitle":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/bg-title_offshore_whitepaper.png","width":418,"height":117},"description":"<p class=\\"mb-6\\">With globalization on the rise, businesses increasingly rely on professional service for entity formation. But firms are faced with a shortage of specific skillsets to bring out edges - and, most importantly, meet clients\' expectations.</p><p>Entity formation has no longer lain in specialized knowledge and deep expertise, professional service firms must quickly adapt to global landscape and grasp opportunities in newly digitized world.</p>","descriptionMobile":"Professional service firms are struggling with entity formation and global compliance issues. It\'s time to grasp opportunities in a newly digitized world.","tag":"Whitepaper","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/banner-offshore-whitepaper.png","width":1920,"height":1276},"imageMb":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/bannermb-offshore-whitepaper.png","width":375,"height":640},"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool","uri":"/guide-and-tool"},{"title":"Whitepaper"}],"imageBottom":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/tablet-offshore-whitepaper.png","width":918,"height":678}},"ebookImage":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/section_1-offshore-whitepaper.png","width":540,"height":540},"dataServiceFirm":{"title":"Professional service firms <span class=\'text-[#FF5630]\'>- Who are they?</span>","leftContent":{"description":"The term refers to any firm or profession that offers specialized, knowledge-based service to clients in certain business areas.","descriptionMobile":"The term refers to any firm or profession specialized in certain business areas, particularly related to advisory, management, and consulting services.","title":"How people bring the term to mind?","listContent":[{"subTitle":"Mid-1960s","content":"Ever since the spectacular rise of the consulting sector in the \'mid-1960s\', the term \'professional service\' has increasingly been associated with management and business consulting services."},{"subTitle":"Now","content":"As a result, when people refer to the professional service industry, they often refer to the market related to advisory services in the field of strategy, management and organization."}]},"rightContent":[{"icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/law1-offshore-whitepaper.png","width":80,"height":80},"text":"Lawyers","background":"#FF5630"},{"icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/accounting1-offshore-whitepaper.png","width":80,"height":81},"text":"Accountants","background":"#0055CC"},{"icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/evaluation1-offshore-whitepaper.png","width":80,"height":81},"text":"Financial advisers","background":"#00A6FF"},{"icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/profile1-offshore-whitepaper.png","width":80,"height":81},"text":"Business consultants","background":"#FFAB00"}]},"dataTitle":[{"title":"Market segments","description":""},{"title":"A booming Industry","description":"The professional service industry is enjoying a boom, witnessing the highest demand for advisory services as the economy recovers and markets reopen."},{"title":"The world\'s powerhouses","description":"There are 2,392,685 professional service firms worldwide. The United States, the United Kingdom, and Canada are among the countries with the largest number. Regionally, North America and Europe have the largest number."},{"title":"Biggest players in the field","description":"The professional service industry is dominated by a small group of players that have major presence in the continent."}],"dataChart":[{"title":"Market segments","style":"segments","text":"The professional service consists of more than 200 different segments.","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/segment-offshore-whitepaper.png","width":749,"height":154},"source":"Source: <a href=\'https://www.consultancy.org/\' target=\'_blank\' rel=\'noreferrer nofollow\' class=\'underline\'>Consultancy.org</a>"},{"title":"A booming Industry","style":"booming","description":"The professional service industry is enjoying a boom, witnessing the highest demand for advisory services as the economy recovers and markets reopen.","note":"*compound annual growth rate","source":"Source: Statista | Market size of the professional services industry worldwide from 2018 to 2021 with a forecast for 2022 and 2025","horizon":["2018","2019","2020","2021","2022","2025"],"vertical":["200 Bil","400 Bil","600 Bil","800 Bil","1000 Bil","1200 Bil"],"listItem":[{"year":"2018","height":"79%","heightMb":"73%","data":"$977.3<br/>billion"},{"year":"2019","height":"75%","heightMb":"69%","data":"$902.3<br/>billion"},{"year":"2020","height":"68%","heightMb":"62%","data":"$819.79<br/>billion"},{"year":"2021","height":"73%","heightMb":"67%","data":"$891.88<br/>billion"},{"year":"2022","height":"80%","heightMb":"74%","data":"$973.67<br/>billion"},{"year":"2025","height":"98%","heightMb":"92%","data":"$1201.06<br class=\'xl:hidden block\' /> billion<br/>(expected)<br/>CAGR* of 8%"}]},{"title":"The world\'s powerhouses","style":"powerhouses","description":"The US, UK, and Canada are the top three countries with the largest number of professional services. Regionally, North America and Europe have the largest number.","source":"Source: <a href=\'https://www.consultancy.org/\' target=\'_blank\' rel=\'noreferrer nofollow\' class=\'underline\'>Consultancy.org</a>","chartTitle":"The size of consulting markets","leftContent":[{"name":"North America","value":"49%","height":"45%","color":"#0055CC"},{"name":"Europe","value":"28%","height":"28%","color":"#007EFF"},{"name":"Asia Pacific","value":"15%","height":"15%","color":"#3388FF"},{"name":"Latin America","value":"3%","height":"6%","color":"#66A6FF"},{"name":"Middle East","height":"3%","color":"#99C3FF"},{"name":"Africa","height":"3%","color":"#c5dcfc"}],"rightContent":[{"name":"United States","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/us-offshore-whitepaper.png","width":24,"height":24},"width":"90%","value":"44,5%"},{"name":"United Kingdom","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/uk-offshore-whitepaper.png","width":24,"height":24},"width":"80%","value":"6,8%"},{"name":"Germany","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/germany-offshore-whitepaper.png","width":24,"height":24},"width":"76%","value":"6,5%"},{"name":"Australia","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/australia-offshore-whitepaper.png","width":24,"height":24},"width":"40%","value":"3,8%"},{"name":"France","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/france-offshore-whitepaper.png","width":24,"height":24},"width":"38%","value":"3,5%"},{"name":"China","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/china-offshore-whitepaper.png","width":24,"height":24},"width":"36%","value":"3,4%"},{"name":"Canada","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/canada-offshore-whitepaper.png","width":24,"height":24},"width":"32%","value":"2,7%"},{"name":"India","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/india-offshore-whitepaper.png","width":24,"height":24},"width":"25%","value":"1,8%"},{"name":"Spain","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/spain-offshore-whitepaper.png","width":24,"height":24},"width":"15%","value":"1.0%"},{"name":"Japan","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/japan-offshore-whitepaper.png","width":24,"height":24},"width":"13%","value":"0,9%"},{"name":"Italy","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/italy-offshore-whitepaper.png","width":24,"height":24},"width":"13%","value":"0,9%"},{"name":"Netherlands","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/netherlands-offshore-whitepaper.png","width":24,"height":24},"width":"13%","value":"0,9%"},{"name":"Saudi Arabia","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/saudi-offshore-whitepaper.png","width":24,"height":24},"width":"13%","value":"0,9%"},{"name":"Switzerland","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/switzerland-offshore-whitepaper.png","width":24,"height":24},"width":"11%","value":"0,8%"},{"name":"Brazil","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/brazil-offshore-whitepaper.png","width":24,"height":24},"width":"11%","value":"0,8%"},{"name":"Sweden","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/sweden-offshore-whitepaper.png","width":24,"height":24},"width":"11%","value":"0,8%"},{"name":"Belgium","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/belgium-offshore-whitepaper.png","width":24,"height":24},"width":"7%","value":"0,5%"},{"name":"Russia","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/countries/russia-offshore-whitepaper.png","width":24,"height":24},"width":"5%","value":"0,3%"}]},{"title":"Biggest players in the field","style":"players","description":"The professional service industry is dominated by a small group of players that have major presence in the continent.","source":"Source: <a href=\'https://www.consultancy.org/\' target=\'_blank\' rel=\'noreferrer nofollow\' class=\'underline\'>Consultancy.org</a>","listItem":[{"name":"Accenture","width":"90%","value":"24,200"},{"name":"Deloitte","width":"77%","value":"22,500"},{"name":"PwC","width":"46%","value":"14,400"},{"name":"EY","width":"30%","value":"14,000"},{"name":"KPMG","width":"20%","value":"11,950"},{"name":"McKinsey & Company","width":"16%","value":"10,500"},{"name":"Boston Consulting Group","width":"10%","value":"8,500"},{"name":"Booz Allen Hamiton","width":"8%","value":"6,700"},{"name":"Mercer","width":"6%","value":"5,000"},{"name":"Bain & Company","width":"4%","value":"4,500"}]}],"dataFormDownload":{"id":"whitepaper","title":"Get your exclusive whitepaper today","description":"Discover how professional firms are keeping their doors open in a digitally competitive landscape by filling out the form below."},"dataAdversity":{"title":"in adversity lies opportunity","background":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/bg_adversity-offshore-whitepaper.png","width":1924,"height":1929},"description1":"Professional service is a market where obstacles and opportunities co-exist. Amongst all upheaval, there is no shortage of potential clients for professional firms. Businesses are crying out for advice and support in entity formation, whether for structure advisory or regulatory. Firms are in a great position to capitalize on the growing market if they can spot opportunities to develop and nurture, as well as position themselves for growth effectively.","description2":"We break down the set of co-existed challenges and opportunities for professional services.","descriptionMobile":"Professional service is a market where obstacles and opportunities co-exist. To capitalize on the expanding market, firms need to spot opportunities among challenges and nurture their growth potential.","note":"Source: Deltek | Insight to Action – The Future of the Professional Services Industry | Base: 350 leaders of professional service firms","listContent":[{"data":[{"title":"Compliance risks","titleMb":"Compliance risks","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/compliant1-offshore-whitepaper.png","width":64,"height":64},"content":["Staying compliant has become harder as professional firms face an array of different regulations, raising the risk of unintended errors.","Numerous firms have already suffered the consequences of failing to comply with global standards."],"contentMb":["Various regulations raise the risk of error. Firms have suffered consequences for failing to comply with globals standard."],"customText":"<p class=\'px-4 py-2 flex bg-bbc-brand-100 text-bbc-brand-700 font-normal rounded-lg items-center\'><span class=\'text-[#FF5630] mr-2 text-bbc-40px font-semibold\'>63% </span><span>of firms see compliance as top challenge</span></p>"},{"title":"The tough love firms need to thrive","titleMb":"Tough Love For Firms","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/growth1-offshore-whitepaper.png","width":64,"height":64},"content":["Firms that faced regulatory risks regularly are more motivated to develop a better compliance process within their organizations.","Senior executives rank compliance as a priority, and <span class=\'text-bbc-brand-600 font-semibold\'>2/3</span> of them are strengthening compliance procedures through internal training, automation, and digitalization."],"contentMb":["Compliance risks motivate firms to make positive changes. Over 400 firms are strengthening their compliance procedures through training, automation, and digitalization."],"sourceText":"Source: EY | Compliance Risk Survey | Base: 510 global board directors from organizations with greater than US$1b revenue across a number of industries"}]},{"data":[{"title":"Slow technology adoption","titleMb":"Slow To Adopt Technology","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/responsive1-offshore-whitepaper.png","width":64,"height":64},"content":["Professional firms are falling behind digital race, mostly because the price of both implementing technology and training staff to use it correctly can be tough to justify.","The increasing pace of technological change means that firms\' advisories are out of date nearly as soon as they are made."],"contentMb":["Increased pace of technological change means that firms\' advisories are out of date as soon as they are made."],"customText":"<p class=\'px-4 py-2 flex bg-bbc-brand-100 text-bbc-brand-700 font-normal rounded-lg items-center\'><span class=\'text-[#FF5630] text-bbc-40px mr-2 font-semibold\'>36% </span><span>of professional firms are hesitant to embrace digitization because they\'re unsure where to begin.</span></p>"},{"title":"Digital transformation during a crisis","titleMb":"Transformation During Crisis","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/digital1-offshore-whitepaper.png","width":64,"height":64},"content":["Technology transformation can be fruitful as it helps professional firms to differentiate from the competition, add value for clients, improve operations, and pursue new growth opportunities.","<span class=\'text-bbc-brand-600 font-semibold\'>49%</span> of professional firms invest in technology see greater profits in 2021."],"contentMb":["Technology helps firms to differentiate from the competition, add value for clients, improve operations, and pursue new growth opportunities.","<span class=\'text-bbc-brand-600 font-semibold\'>49%</span> of professional firms invest in technology see greater profits in 2021."],"sourceText":"Source: Fujitsu | Global Digital Transformation Survey Report 2021 | Base: 1,200 business leaders across 9 countries"}]},{"data":[{"title":"Lack knowledge of global entity formation","titleMb":"Lacking Practical Knowledge","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/earth1-offshore-whitepaper.png","width":64,"height":64},"content":["While clients\' global reach is rapidly expanding, reaching unfamiliar regions such as the Southeast or Midwest, firms are hitting roadblocks simply because they lack sufficient experience in entity formation in each country.","Failure to gather the necessary resources and expertise, as well as a lack of familiarity with foreign jurisdictions, can result in compliance risks and reputation damage."],"contentMb":["Firms are hitting roadblocks due to the lack of sufficient experience in entity formation in each country, leading to compliance risks and reputation damage."],"customText":"<p class=\'px-4 py-2 bg-bbc-brand-100 text-bbc-brand-700 font-normal rounded-lg\'><span class=\'text-[#FF5630] font-semibold\'><span class=\'text-2xl\'>1</span> in <span class=\'text-2xl\'>5</span> </span>professional firms said they were turning down work because they lacked relevant market knowledge.</p>"},{"title":"Global expansion brings chances of growth","titleMb":"New Chances Of Growth","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/economy1-offshore-whitepaper.png","width":64,"height":64},"content":["As international expansion becomes more complex, so do the needs of the businesses tapping professional services.","Firms are expected to be experts in local law, regulations, and other domestic specialties for every possible country. This, in turn, enable professional firms to emerge in terms of expertise and experience to thrive in unfamiliar new landscape."," <span class=\'text-bbc-brand-600 font-semibold\'>47%</span> of businesses worldwide already operate in more than 10 international markets, while <span class=\'text-bbc-brand-600 font-semibold\'>28%</span> seek professional assistance with local regulatory or legal issues."],"contentMb":["Demands for practical specialties enable firms to emerge in terms of expertise, knowledge, and experience","<span class=\'text-bbc-brand-600 font-semibold\'>28%</span> of businesses worldwide seek assistance from professional services in local regulatory and legal issues."],"sourceText":"Source: Mazars | Business Without Borders Report 2021 | Base: 150 executives of middle market companies"}]},{"data":[{"title":"Struggle with unfamiliar scope of service","titleMb":"Unfamiliar Scope Of Service","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/question1-offshore-whitepaper.png","width":64,"height":64},"content":["As clients\' needs evolve, firms may find themselves stumbling into unfamiliar scopes of service. For instance, a client starting a company in other regions may expect superlative service such as business bank account opening.","Local banking laws and policies towards foreign entities make this task even more difficult, necessitating a significant amount of unpaid time and uncompensated resources."],"contentMb":["As clients\' needs evolve, firms may find themselves stumbling into unfamiliar scopes of service."],"customText":"<p class=\'px-4 mb-8 py-2 bg-bbc-brand-100 text-bbc-brand-700 font-normal rounded-lg\'>Despite a <span class=\'text-[#FF5630] font-semibold text-2xl\'>14.5%</span> increase in bank account opening, <span class=\'text-[#FF5630] text-2xl font-semibold\'>49%</span> of professional services worldwide do not feel prepared to meet these needs.</p>","customTextMb":"<p class=\'px-4 py-2 flex bg-bbc-brand-100 text-bbc-brand-700 font-normal rounded-lg items-center\'><span class=\'text-[#FF5630] mr-2 text-bbc-40px font-semibold\'>49% </span>of professional services worldwide do not feel prepared to meet clients\' needs.</p>"},{"title":"Behind every demand is a silver lining","titleMb":"Behind Every Demand Is A Silver Lining","icon":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/solution1-offshore-whitepaper.png","width":64,"height":64},"content":["Living up to client expectations can be exhausting, but firms now have more opportunities to turn these situation into positive changes within their organization, improve the level of services rendered, deepening relationship with client, and deliver better value-added solutions for future projects.","<span class=\'text-bbc-brand-600 font-semibold\'>28%</span> of clients say adding value is their number one priority when choosing a professional service."],"contentMb":["New demands bring positive changes to professional service, offering chances for improvement, deepening relationship with client, and deliver better value-added solutions for future projects."]}]}]},"dataIncorpSlide":[{"title":"Digital incorporation eases compliance issues","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/issue-offshore-whitepaper.png","width":281,"height":280,"alt":"issues"},"content":["By digitizing entity formation process, firms can ensure full-coverage compliance for clients in multi-jurisdictions.","The integration of regulatory monitoring and compliance timeline helps firms keep track of requirements to be met whenever a new entity is formed.","Digital incorporation also assists professional firms in keeping communication consistent, secure, and effective, reducing non-compliance risks and human errors for each project."],"contentMb":["By digitizing entity formation process, firms can ensure full-coverage compliance for clients in multi-jurisdictions, keep track of risk assement when forming new company, and reduce risks for each project."]},{"title":"Outsourcing is the secret to tech adoption success","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/outsource-offshore-whitepaper.png","width":280,"height":280,"alt":"outsourcing"},"content":["Professional services choose to outsource the role and function of digital incorporation as a way to transform their firms digitally.","Outsourcing provides firms with vetted experts who have hands-on experience in technologies critical to entity formation, from online data collection, streamlined protocols, auto-verification, and centralized storage, to e-signature and digital forms. Engaging an outsourcing partner helps firms automatize work process for a simpler, faster, and safer entity formation.","90% of professional firms take assistance from a third-party solution provider to help them with at least one element of entity formation."],"contentMb":["Professional services choose to outsource the role and function of digital incorporation as a way to transform their firms digitally.","90% firms outsource from a third-party with at least one element of entity formation."]},{"title":"Tune in to clients\' special needs","image":{"src":"/assets/images/offshore/guide-and-tool/whitepaper/client-offshore-whitepaper.png","width":280,"height":280,"alt":"client"},"content":["Digital incorporation is the same process of entity formation, but covers a wider scope of services such as bank account opening, tax filing, accounting & auditing, and more.","These additional supports help firms cater for clients\' demands in all areas, cutting down on costs and workload during entity formation process.","59% of firms save costs by using an ancillary service to perform duties that were often done in-house before. "],"contentMb":["Digital incorporation is the same process of entity formation, but cover a wider scope of services e.g., bank account opening, tax filing, accounting & auditing, and more.","59% of firms save costs by using an ancillary service for tasks that were done in-house before."]}],"dataBeOurPartner":[{"title":"Company Formation","link":"/offshore/company-formation","description":"We provide fast & streamlined process for entity formation to optimize your entire clients\' journey."},{"title":"Banking Support","link":"/offshore/banking-support","description":"We support bank account opening with high-success-rate banks, saving you time and effort to open bank accounts for clients."},{"title":"Accounting","link":"/offshore/accounting-and-auditing","description":"Our qualified accounting service helps you handle complexities of annual accounting tasks for clients with ease."}]}');
;// CONCATENATED MODULE: ./pages/offshore/guide-and-tool/whitepaper/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      customMenu: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(whitepaper, {
        data: data_namespaceObject,
        posts: data.posts
      })
    })
  });
}

/***/ }),

/***/ 95205:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/guide-and-tool/whitepaper",
      function () {
        return __webpack_require__(16382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"WhitepaperTitle":"Index_WhitepaperTitle__vRc8r","WhitepaperModal":"Index_WhitepaperModal__qQQhD","Select":"Index_Select__9X2HR"};

/***/ }),

/***/ 30103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"charts":"Index_charts__qKkox","fillup":"Index_fillup__5_iXC","fade":"Index_fade__Z9Ns9","fillhorizon":"Index_fillhorizon__kUWIC","lastSection":"Index_lastSection__d9Ply"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9885,8352,4090,9738,7447,477,9774,2888,179], function() { return __webpack_exec__(95205); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);